export const styles = {
  container: {
    backgroundColor: '#f9f9ff',
    height: 'calc(100vh - 72px)',
    padding: '32px 35px 20px 40px',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    fontWeight: 700,
    color: '#4F5B94',
    cursor: 'pointer',
    gap: '10px',
  },
  title: {
    fontSize: '32px',
    fontWeight: 500,
    color: '#011533',
    marginBottom: '12px',
  },
  description: {
    width: '100%',
    maxWidth: '900px',
    color: '#011533',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 400,
    marginBottom: '32px',
  },
  subtitle: {
    color: '#0C172C',
    fontSize: '18px',
    lineHeight: '26px',
    fontWeight: 700,
    margin: '20px 0',
  },
  addKeysWrapper: {
    background: '#FFFFFF',
    boxShadow: '0px 2px 6px 0px rgba(39, 55, 84, 0.08)',
    width: '1060px',
    height: '90px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
  },
  addKeysInputsMainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '58px',
  },
  inputsRow: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    '& > div': {
      marginRight: '16px',
    },
  },
  button: {
    minWidth: '124px',
    paddingTop: '4px',
    paddingBottom: '4px',
    borderRadius: '12px',
    height: '32px',
    backgroundColor: '#ee4360',
    color: '#FFFFFF',
    textTransform: 'none',
    border: '1px solid #ee4360',
    padding: '7px 20px',
    alignSelf: 'flex-end',
    '&:hover': {
      backgroundColor: '#ee4360',
    },
  },
  customInputHeight: {
    '& input': {
      height: '34px !important',
    },
  },
}
